import React from 'react';

/**
 * Full-area loading state shown while auth and route guards resolve.
 * Centers a brand-colored animated spinner in the main content region.
 */
export const LoadingScreen: React.FC = () => (
  <div className="loading-screen">
    <div className="brand-spinner" role="status" aria-live="polite" aria-label="Loading">
      <span className="brand-spinner__ring brand-spinner__ring--outer" />
      <span className="brand-spinner__ring brand-spinner__ring--middle" />
      <span className="brand-spinner__ring brand-spinner__ring--inner" />
    </div>
  </div>
);
